import React from 'react';
import './select-all-menu.scss';
import { Checkbox } from '@ampol/design-system';

const SelectAllMenu = ({ selectedItemNo, isSelected, triggerSelectAll }) => {
  const checkBoxHandler = (event) => triggerSelectAll(event.target.checked, false);

  return (
    <>
      <div className="select-all-checkbox-content">
        <Checkbox
          color={'blue'}
          name={'content-checker'}
          aria-label="select all checkbox"
          onChange={checkBoxHandler}
          checked={isSelected}
        />
        <div className="selection-info">
          {`${selectedItemNo} item${selectedItemNo !== 1 ? 's' : ''} selected`}
        </div>
      </div>
    </>
  );
};

export default SelectAllMenu;
